export default function languageChange() {
    $(".select-language").on("change", function() {
      var link = $(this).val();
      window.open(link, "_self");
    });
  }
  